"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_js_1 = require("chart.js");
chart_js_1.Chart.register(chart_js_1.CategoryScale, chart_js_1.LineController, chart_js_1.LineElement, chart_js_1.LinearScale, chart_js_1.PointElement, chart_js_1.Tooltip);
function DisplayLineChart(canvas, labels, data, max) {
    // Case where there are no data points
    if (labels.length === 0 && data.length === 0) {
        labels = ["", ""];
        data = [0, 0];
    }
    // Case where there is only one data point, we duplicate it to have a line.
    else if (labels.length === 1 && data.length === 1) {
        labels = [...labels, "Aujourd'hui"];
        data = [data[0], data[0]];
    }
    // All labels and data except the last one.
    const completedLabels = labels.slice(0, -1);
    const completedData = data.slice(0, -1);
    // Data of the current trimester.
    const currentTrimesterData = data.slice(-1);
    new chart_js_1.Chart(canvas, {
        type: "line",
        data: {
            labels: labels,
            datasets: [
                // All the completed trimester are displayed as a solid line.
                {
                    data: completedData,
                    borderColor: "rgba(75, 192, 192, 1)",
                    borderWidth: 5,
                },
                // The current trimester is displayed as a dashed line.
                {
                    data: [
                        ...Array(completedLabels.length - 1).fill(null),
                        ...completedData.slice(-1), // The last value of the completed data
                        ...currentTrimesterData, // The current trimester data
                    ],
                    borderColor: "rgba(75, 192, 192, 1)",
                    borderWidth: 5,
                    borderDash: [5, 10],
                },
            ],
        },
        options: {
            scales: {
                y: {
                    beginAtZero: true,
                    max: max,
                },
            },
            locale: "fr",
            plugins: {
                tooltip: {
                    padding: 20,
                    mode: "nearest",
                    displayColors: false,
                    // Disable the tooltip for the first data point of the current
                    // trimester, to avoid showing the tooltip twice, one for the last
                    // point of the previous trimesters and one for the first point of the
                    // current trimester.
                    filter: function (tooltipItem, data) {
                        return !(tooltipItem.datasetIndex === 1 &&
                            tooltipItem.dataIndex === completedData.length - 1);
                    },
                },
            },
        },
    });
}
const data = JSON.parse(document.getElementById("data").text);
DisplayLineChart(document.getElementById("ads-count"), Object.keys(data.ads_by_trimester), Object.values(data.ads_by_trimester), 
// Hardcode the maximum value to 60000, because there are approximately 60000
// in total. If we don't hardcode the value, the maximum value of the graph
// corresponds to +- the number of ADS which we registered in the database,
// which might be confusing.
60000);
DisplayLineChart(document.getElementById("ads-manager-requests-count"), Object.keys(data.ads_manager_by_trimester), Object.values(data.ads_manager_by_trimester));
DisplayLineChart(document.getElementById("relais-proprietaires-count"), Object.keys(data.proprietaire_by_trimester), Object.values(data.proprietaire_by_trimester));
DisplayLineChart(document.getElementById("relais-vehicules-count"), Object.keys(data.vehicule_by_trimester), Object.values(data.vehicule_by_trimester));
